import axios from 'axios';

let cache = null;

const getVillagers = async () => {
  if (cache != null) {
    return cache;
  }

  const { data } = await axios.get('/api/villagers', {
    params: { all: 'all' },
  });

  cache = data;
  return data;
};

export default getVillagers;
